import styled from 'styled-components';
import {
  DropdownTagsControl,
  FiltersGroup,
  type TagOption,
  TagsControl
} from '@elfsight/widget-filters';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';

type TagsControlWrapperProps = {
  setting: string;
  label: string;
  type: string;
  options: TagOption[];
};

export const TagsControlWrapper = ({
  setting,
  label,
  type,
  options
}: TagsControlWrapperProps) => {
  const { backgroundColor } = useSettings();

  if (type === 'inline') {
    return (
      <TagControlWrapper _background={backgroundColor}>
        <DropdownTagsControl
          label={label}
          filterName={setting}
          options={options}
        />
      </TagControlWrapper>
    );
  }

  return (
    <FiltersGroup key={type} title={label}>
      <TagsControl filterName={setting} options={options} />
    </FiltersGroup>
  );
};

const TagControlWrapper = styled.div.attrs({
  className: createReadableClass({
    component: 'filters',
    element: 'tag-wrapper'
  })
})<{ _background: string }>`
  border-radius: 8px;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  background-color: ${({ _background }) => _background};
`;
